import type { DeepPartial } from '@luna/utils-ts';

import type { StatementsConfig } from '../StatementsConfig';

export const statements: DeepPartial<StatementsConfig> = {
    enabled: true,
    tableColumns: [
        {
            id: 'name',
            labelKey: 'account.buildingSociety.statements.nameColumn',
            labelize: true,
            header: true,
            width: '45%',
        },
        {
            id: 'date',
            labelKey: 'account.buildingSociety.statements.yearColumn',
            labelize: true,
            header: true,
            width: '45%',
        },
        {
            id: 'download',
            labelKey: '',
            labelize: false,
            header: true,
            width: '10%',
        },
    ],
    downloadRequestType: 'GET',
};
